import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

import styles from './index.css';

const TestableUnordered = testable(QA_MALT, 'ul');
const TestableOrdered = testable(QA_MALT, 'ol');

const List = ({
  level = 2,
  levelConfined,
  levelWide,
  className,
  children,
  ordered = false,
  noMargin,
  testId,
}) => {
  const TestableElement = ordered ? TestableOrdered : TestableUnordered;
  return (
    <TestableElement
      className={classNames(
        styles.list,
        styles[`list${level}`],
        {
          [styles.noMargin]: noMargin,
          [styles[`listConfined${levelConfined}`]]: levelConfined,
          [styles[`listWide${levelWide}`]]: levelWide,
        },
        className
      )}
      testId={testId}
    >
      {children}
    </TestableElement>
  );
};

List.displayName = 'List';

List.propTypes = {
  /** define the level of the list to adjust font size */
  level: PropTypes.oneOf([1, 2, 3]),
  /** define the level of the list  to adjust font size in tablet breaking point  */
  levelConfined: PropTypes.oneOf([1, 2, 3]),
  /** define the level of the list  to adjust font size in desktop breaking point  */
  levelWide: PropTypes.oneOf([1, 2, 3]),
  /** toggle an ordered list instead of an unordered list */
  ordered: PropTypes.bool,
  /** set the elements margin to 0 */
  noMargin: PropTypes.bool,
  /** add a custom className to the component */
  className: PropTypes.string,
  /** insert children – should be list items */
  children: PropTypes.node.isRequired,
  /** define a testid for the list */
  testId: PropTypes.string,
};

export default List;
